import React, { useCallback, useEffect, useMemo, useState, memo } from 'react';
import { ChevronDownIcon, ChevronUpIcon, SearchIcon, XIcon } from 'lucide-react';
const FAQ = () => {
  const faqs = useMemo(() => [{
    id: 1,
    question: '¿Y si no funciona para mí?',
    answer: 'Este sistema tiene garantía. Y si no te ayuda, te devolvemos tu dinero sin hacer preguntas. Tienes 30 días para probarlo con total tranquilidad.',
    category: 'garantía',
    popular: true
  }, {
    id: 2,
    question: '¿Es seguro?',
    answer: 'Totalmente. Está recomendado por médicos y terapeutas. No tiene contraindicaciones ni utiliza químicos. La tecnología está certificada y cumple con todos los estándares de seguridad internacionales.',
    category: 'seguridad',
    popular: true
  }, {
    id: 3,
    question: '¿Es fácil de usar?',
    answer: 'Para usarlo en caliente, solo colócalo en el microondas durante 1 a 2 minutos y colócalo sobre tu cabeza. Para frío, déjalo en el congelador entre 30 y 60 minutos. Gracias a su diseño ergonómico tipo gorro, se adapta perfectamente sin necesidad de ajustarlo constantemente.',
    category: 'uso',
    popular: false
  }, {
    id: 4,
    question: '¿Cuánto tiempo debo usarlo?',
    answer: 'Recomendamos 10-20 minutos en modo frío y aproximadamente 10 minutos en modo caliente. Puedes ajustar el tiempo según tu nivel de dolor y preferencia personal. Para resultados óptimos, úsalo de forma rutinaria.',
    category: 'uso',
    popular: false
  }, {
    id: 5,
    question: '¿Funciona para todo tipo de dolor?',
    answer: 'Ha mostrado resultados positivos en migrañas, dolores de cabeza tensionales, dolor cervical, dolor de espalda, fibromialgia y otros tipos de dolor crónico. Consulta con tu médico para casos específicos.',
    category: 'efectividad',
    popular: true
  }, {
    id: 6,
    question: '¿Qué garantía tengo al comprarlo?',
    answer: <>
            <p data-id="element-196">30 días para probarlo.</p>
            <p className="mt-2" data-id="element-197">
              Si no sientes un cambio… te devolvemos el dinero. Sin preguntas.
              Sin letras pequeñas.
            </p>
            <p className="mt-2" data-id="element-198">
              Porque <em data-id="element-199">creemos más en tu alivio que en una venta rápida</em>.
            </p>
          </>,
    category: 'garantía',
    popular: false
  }, {
    id: 7,
    question: '¿El pago es seguro y qué métodos de pago tienen?',
    answer: <>
            <p data-id="element-200">
              Sí. Tu compra está protegida con plataformas de pago 100% seguras
              como N1CO y WOMPI si deseas pagar con tarjeta.
            </p>
            <p className="mt-2 font-medium" data-id="element-201">
              También tenemos PAGO CONTRA ENTREGA EN TODO EL SALVADOR
            </p>
            <p className="mt-2" data-id="element-202">
              Además, puedes pagar por transferencia bancaria BAC CREDOMATIC a
              cuenta jurídica a nombre de SHOPYSV. Nuestro número de cuenta es:
              201502648
            </p>
            <p className="mt-2" data-id="element-203">
              Tomas una captura de pantalla y la envías a nuestro número de
              WhatsApp: 7666-8786
            </p>
            <p className="mt-2" data-id="element-204">Correo: contacto@shopysv.com</p>
          </>,
    category: 'pago',
    popular: false
  }, {
    id: 8,
    question: '¿Tendré que pagar algo extra al recibirlo?',
    answer: <>
            <p data-id="element-205">
              No. El precio que ves publicado ya incluye el producto, accesorios
              y envío gratis.
            </p>
            <p className="mt-2" data-id="element-206">
              No tendrás cargos ocultos ni sorpresas al recibirlo.
            </p>
          </>,
    category: 'envío',
    popular: false
  }, {
    id: 9,
    question: '¿Cómo sé que no me van a estafar?',
    answer: <>
            <p data-id="element-207">
              Somos una tienda verificada online y física ubicada en Condominios
              Cuscatlán, local 203 y 216, San Salvador 🛡️
            </p>
            <p className="mt-2" data-id="element-208">
              Además, trabajamos con procesadores de pago reconocidos y
              ofrecemos envío con empresas de mensajería confiables
            </p>
            <p className="mt-2" data-id="element-209">
              Recibirás confirmación y número de rastreo al realizar tu compra.
            </p>
          </>,
    category: 'confianza',
    popular: false
  }, {
    id: 10,
    question: '¿Qué beneficios tengo comprando ahora y no después?',
    answer: <>
            <p className="font-medium" data-id="element-210">✅ Al comprar ahora aseguras:</p>
            <ul className="mt-2 space-y-1 list-disc pl-5" data-id="element-211">
              <li data-id="element-212">Precio promocional activo (puede subir en próximos días).</li>
              <li data-id="element-213">Stock disponible inmediato (la demanda es muy alta).</li>
              <li data-id="element-214">
                Envío prioritario, para que lo recibas antes que otros
                compradores.
              </li>
            </ul>
          </>,
    category: 'promoción',
    popular: true
  }], []);
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [highlightedFaq, setHighlightedFaq] = useState<number | null>(null);
  // Destacar un FAQ aleatorio cada 8 segundos
  useEffect(() => {
    const popularFaqs = faqs.filter(faq => faq.popular);
    const highlightTimer = setInterval(() => {
      const randomIndex = Math.floor(Math.random() * popularFaqs.length);
      setHighlightedFaq(popularFaqs[randomIndex].id);
      // Quitar el resaltado después de 3 segundos
      setTimeout(() => {
        setHighlightedFaq(null);
      }, 3000);
    }, 8000);
    return () => clearInterval(highlightTimer);
  }, [faqs]);
  const toggleFaq = useCallback((index: number) => {
    setOpenIndex(prevIndex => prevIndex === index ? null : index);
  }, []);
  return <section id="faq" className="py-16 md:py-24 bg-[#f8f9ff]" data-id="element-215">
      <div className="container mx-auto px-4 md:px-6" data-id="element-216">
        <div className="max-w-3xl mx-auto" data-id="element-217">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-[#1e293b] text-center" data-id="element-218">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-6" data-id="element-219">
            {faqs.map((faq, index) => <div key={faq.id} className={`border-2 rounded-xl overflow-hidden bg-white shadow-sm transition-all duration-300 
                  ${openIndex === index ? 'border-[#8b5cf6] shadow-md' : 'border-[#e2e8f0] hover:border-[#d1d5db]'}
                  ${highlightedFaq === faq.id ? 'animate-pulse border-[#6366f1]' : ''}`} data-id="element-220">
                <button className="w-full flex justify-between items-center p-6 text-left focus:outline-none" onClick={() => toggleFaq(index)} aria-expanded={openIndex === index} aria-controls={`faq-answer-${faq.id}`} data-id="element-221">
                  <h3 className={`text-lg md:text-xl font-medium ${openIndex === index ? 'text-[#6366f1]' : 'text-[#1e293b]'}`} data-id="element-222">
                    {faq.question}
                    {faq.popular && <span className="ml-2 bg-[#f0f9ff] text-[#0284c7] text-xs font-medium px-2 py-0.5 rounded-full" data-id="element-223">
                        Popular
                      </span>}
                  </h3>
                  <div className={`flex items-center justify-center w-8 h-8 rounded-full transition-colors ${openIndex === index ? 'bg-[#eef2ff]' : 'bg-[#f8fafc]'}`} data-id="element-224">
                    {openIndex === index ? <ChevronUpIcon size={18} className="text-[#6366f1]" data-id="element-225" /> : <ChevronDownIcon size={18} className="text-[#6366f1]" data-id="element-226" />}
                  </div>
                </button>
                <div id={`faq-answer-${faq.id}`} className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-[500px] pb-6' : 'max-h-0'}`} data-id="element-227">
                  <div className="text-[#4a5568] leading-relaxed" data-id="element-228">
                    {faq.answer}
                  </div>
                  {/* Botón de "Fue útil" */}
                  {openIndex === index && <div className="mt-4 pt-4 border-t border-[#e2e8f0] flex justify-between items-center" data-id="element-229">
                      <div className="text-sm text-[#718096]" data-id="element-230">
                        ¿Te resultó útil esta respuesta?
                      </div>
                      <div className="flex space-x-2" data-id="element-231">
                        <button className="px-3 py-1 bg-[#f8fafc] hover:bg-[#eef2ff] text-[#4a5568] rounded-lg text-sm transition-colors" data-id="element-232">
                          Sí
                        </button>
                        <button className="px-3 py-1 bg-[#f8fafc] hover:bg-[#eef2ff] text-[#4a5568] rounded-lg text-sm transition-colors" data-id="element-233">
                          No
                        </button>
                      </div>
                    </div>}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};
export default memo(FAQ);